import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import CveService from '#services/cve/cve.service';

export const lineOfBusinessValidationGuard = (route: ActivatedRouteSnapshot): Observable<boolean> => {
  const cveService = inject(CveService);
  const router = inject(Router);

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const lineOfBusiness = route.paramMap.get('lineOfBusiness')!;
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const iterationId = route.paramMap.get('iterationId')!;

  return cveService.getIteration(iterationId).pipe(
    map((iteration) => {
      if (!iteration) {
        // TODO: redirect to a 404 page ? (and return false here)
        return true;
      }

      if (iteration.lineOfBusiness.toLowerCase() !== lineOfBusiness) {
        const segmentsAfterIterationId = route.url.slice(3).map((seg) => seg.path);
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        router.navigate(
          [
            `/${iteration.lineOfBusiness.toLowerCase()}`,
            'customerjourney',
            iteration.iterationId,
            ...segmentsAfterIterationId,
          ],
          {
            replaceUrl: true,
          },
        );
        return false;
      }
      return true;
    }),
    catchError(() =>
      // TODO: redirect to a 404 page ?
      of(true),
    ),
  );
};
